/* src/app/modules/shared/components/header-column/header-column-quantity/header-column-quantity.component.scss */
app-header-column-quantity {
  display: contents;
}
/*# sourceMappingURL=header-column-quantity.component.css.map */
